import { ERROR_CODE as a } from "../../constants/error.js";
import { useConfigContext as l } from "../../contexts/config/ConfigContext.js";
import { CustomError as c } from "../../errors/customError.js";
import p from "query-string";
import * as u from "ramda";
import { useState as h, useCallback as i } from "react";
const J = () => {
  const {
    config: n
  } = l(), [f, r] = h(!1), s = i(() => {
    const {
      fetchJson: o
    } = n;
    if (u.isNil(o))
      throw new c('config "fetchJson" is not defined', a.GENERAL.MISSING_CONFIG);
    return o.buildId;
  }, [n]);
  return {
    fetchJson: i(async (o) => {
      r(!0);
      const e = new Headers();
      e.append("content-type", "application/json"), e.append("cache-control", "no-cache");
      try {
        const t = await fetch(p.stringifyUrl({
          url: o,
          query: {
            buildId: s()
          }
        }), {
          method: "GET",
          headers: e
        });
        if (r(!1), t.ok)
          return await t.json();
        throw new c("Cannot fetch static json data", a.FETCH.CANNOT_FETCH_JSON);
      } catch (t) {
        console.error(t.message);
      }
      return null;
    }, [s]),
    loading: f
  };
};
export {
  J as default
};
//# sourceMappingURL=useLazyFetchJson.js.map
